const smoothScroll = () => {
  const $header = $(".js-header");
  $('a[href^="#"]').on("click", function (e) {
    let speed = 500;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top - $header.innerHeight();
    let buffer;
    switch (href) {
      case "#about":
        buffer = 0;
        break;
      case "#linkArea":
        buffer = 0;
        break;
      default:
        buffer = 100;
    }
    $("body").removeClass("is-ovh");
    $(".js-menuButton").removeClass("is-active");
    $(".js-menuButton").next("nav").removeClass("is-active");
    $("html, body").animate({ scrollTop: position + buffer }, speed, "swing");
    return false;
  });
};
export default smoothScroll;



// WEBPACK FOOTER //
// ./src/recruit/js/smoothScroll.js